import _ from 'lodash';
import React from 'react';
import propTypes from 'prop-types';
import exif from 'exif-js';
import exif2css from 'exif2css';

const ORIENTATION_TAG = 'Orientation';

class Image extends React.Component {
  static propTypes = {
    src: propTypes.string.isRequired,
    defaultImage: propTypes.string,
    alt: propTypes.string,
    className: propTypes.string,
  };

  static defaultProps = {
    alt: '',
    className: '',
    defaultImage: '',
  };

  constructor(props) {
    super(props);
    const { defaultImage } = this.props;
    this.onImageError = this.onImageError.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);
    this.state = {
      orientationStyle: {},
      orientation: null,
      defaultImage,
    };
  }

  onImageLoad(e) {
    const imageElement = e.target;
    this.rotateImageIfNeeded(imageElement);
  }

  onImageError(event) {
    const imgDOM = event.currentTarget;
    imgDOM.src = this.state.defaultImage;
    return true;
  }

  rotateImageIfNeeded(imageElement) {
    exif.getData(imageElement, () => {
      const orientation = exif.getTag(imageElement, ORIENTATION_TAG);
      const orientationStyle = this.transKeysToCamelCase(exif2css(orientation));
      if (!_.isEmpty(orientationStyle)) {
        this.setState({ orientationStyle, orientation });
      }
    });
  }

  // NOTE: this utility transforsm css style like 'transform-origin' to 'transformOrigin'.
  transKeysToCamelCase(obj) {
    return _.keys(obj).map(key => ({ [_.camelCase(key)]: obj[key] }))
      .reduce((a, b) => ({ ...a, ...b }), {});
  }

  render() {
    const { src, alt, style, className } = this.props;
    const { orientationStyle, orientation } = this.state;
    const mergedStyle = orientation ? { ...orientationStyle, ...style } : style;

    // NOTE: key prop here is to fix the update issue with "Avatar" in EditProfile Page.
    // check this issue, https://github.com/facebook/react-native/issues/9195
    return (
      <img
        key={`${src}${alt}`}
        src={src}
        alt={alt}
        style={mergedStyle}
        className={className}
        onLoad={this.onImageLoad}
        onError={this.onImageError}
      />
    );
  }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/shared/Image.js